<template>
  <LinkCss :href="getWithHost(tailwindCss)" v-model:on-load-end="show" />
  <body v-show="show" data-theme="light">
    <SearchInput
      :key="key"
      :props="propsParsed"
      @value="emit('value', $event)"
      @enter="
        () => {
          emit('enter')
        }
      "
      @restart="key++"
    ></SearchInput>
  </body>
</template>
<script lang="ts" setup>
import SearchInput from '@/components/SearchInput.vue'
import LinkCss from '@/components/LinkCss.vue'
import tailwindCss from '@/styles/style.css?url'
import { ref } from 'vue'
import { getWithHost } from '@/utils/utils'

const props = defineProps<{
  props: string
}>()
const emit = defineEmits<{
  (e: 'value', v: string): void
  (e: 'enter'): void
}>()
const key = ref(0)

const propsParsed = JSON.parse(props.props)

const show = ref(false)
</script>
